import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getISTDate, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { dateFormatter } from '../../../../../utils';
import { PHARMACY_INVOICE_FROM } from '../../../../../constants/dropdown';
import { SelectDoctorTable } from '../../HMS/masters/others/SelectDoctorTable';


const TAX_SUMMARY_HEADER = [
  { header: 'GST%', accessor: 'gst' },
  {
    header: 'Taxable Amount',
    accessor: 'TaxableAmount'
  },
  { header: 'CGST Amt', accessor: 'cgst' },
  { header: 'SGST Amt', accessor: 'sgst' }
];

const POS_TABLE_COLUMNS = [
  {
    header: 'Retail No.',
    accessor: 'inv_no'
  },
  {
    header: 'Date',
    accessor: (row) => dateFormatter(row?.createdAt)
  },
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },
  {
    header: 'UHID No.',
    accessor: 'uhid'
  }
];

const TABLE_HEADER = [
  {
    header: 'Return No',
    accessor: 'ret_no'
  },
  {
    header: 'Return Date',
    accessor: (row) => dateFormatter(row?.date)
  },
  {
    header: 'Retail No.',
    accessor: 'retail_no'
  },
  {
    header: 'Location Name',
    accessor: (row) => row?.location?.warehouse_name
  },
  {
    header: 'Account Name',
    accessor: (row)=> row?.account?.ledger_name
  },
  {
    header: 'Pay Mode',
    accessor: 'pay_mode'
  },
  {
    header: 'Created At',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialConsignmentDataObj = {
  data: [],
  loading: false
};

const initialRetailPos = {
  data: [],
  loading: false
};
export const RetailSaleReturn = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [consignmentDataObj, setConsignmentDataObj] = useState(initialConsignmentDataObj);
  const [retailPosDataObj, setRetailPosDataObj] = useState(initialRetailPos);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [warehouse, setWareHosue] = useState([]);
  const [posDialogueOpen, setPosDialogueOpen] = useState(false);
  const [selectedPos, setSelectedPos] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [totalSum, setTotalSum] = useState(0);
  const [tax, setTax] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const [accountLedger, setAccountLedger] = useState([]);
  const [pendingdata,setPendingData] = useState([])
  const [selectedRows,setSelectedRows] = useState([])
  const [inputPos,setInputPos] = useState('')
  const [selectedRowsdata,setSelectedRowsData]  = useState([])


  useEffect(() => {
    setInputValues((prevValues) => {
      const updatedValues = { ...prevValues };
      detailList.forEach((item) => {
        if (item._id && !updatedValues[item._id]) {
          updatedValues[item._id] = {
            ...item,
            Return_Qty: prevValues[item._id]?.Return_Qty || ''
          };
        }
      });
      return updatedValues;
    });
  }, [detailList]);

const handleSumChange = (newSum) => {
  setTotalSum(newSum);
  const totalGst = tax?.reduce((sum, t) => sum + t.cgst + t.sgst, 0) || 0;
  setValue('item_total_amt', newSum );
};
  
  const handleInputChange = (id, Return_Qty, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [id]: {
        ...prevInputValues[id],
        [Return_Qty]: value
      }
    }));
  };

  const formatDateToMonthYear = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long' };
    return date.toLocaleDateString('en-US', options);
  };
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // invoice_no: Yup.string().required(' '),
        // invoice_from: Yup.string().required(' '),
      })
    ),
    defaultValues: {
       date: getISTDate(),
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const column = watch('view_column');

  const BILL_TABLE_HEADER = [
    {
      header: 'Retail No.',
      accessor: (row) => row?.inv_no
    },
    column ? { header: 'Product Id', accessor: 'product_id' } : null,
    { header: 'Product Name', accessor: (row) => row?.product_name  || row?.product?.main?.name},
    { header: 'Billed/Pending Qty', accessor:(row)=>  row?.remaining_qty || row?.bill_qty },
    { header: 'Return_Qty', accessor: 'return_qty' },
    { header: 'Rate', accessor:  'mrp' },
    { header: 'Disc Amt', accessor:  'disc_amt' },
    { header: 'Amounts', accessor: 'amount' },
    { header: 'Gst Per.', accessor: 'gst' },
    { header: 'Batch No.', accessor: 'batch_no' },
    { header: 'Exp Date', accessor: (row) => formatDateToMonthYear(row?.exp_date) }
  ].filter(Boolean);

  const itemTotalAmt = watch('item_total_amt');
  const billDisc = watch('bill_dis');
  if (itemTotalAmt !== undefined && billDisc !== undefined) {
    const discountAmount = (billDisc / 100) * itemTotalAmt;
    const netAmt = itemTotalAmt - discountAmount;
    if (netAmt !== watch('net_amt')) {
      setValue('net_amt', netAmt);
    }
  }

useEffect(() => {
  const updatedDetailList = pendingdata.map((item) => {
    const productId = typeof item.product === 'object' && item.product !== null
      ? item.product._id
      : item.product;

    const returnQty = inputValues[productId]?.Return_Qty ?? 0;

    if (item.bill_qty < returnQty) {
      toast(`The Return Qty cannot be more than Bill Qty`, { variant: 'warning' });
      return null;
    }

    const mrp = parseFloat(item.mrp || 0);    
    const discPer = parseFloat(item.disc_per || 0);   
    const gstRate = parseFloat(item.gst || 0);    
    const discountedAmount = mrp * (1 - discPer / 100);
    const gstAmount = discountedAmount * gstRate / 100;
    const totalGstAmount = gstAmount * returnQty;
    const taxableAmount = discountedAmount * returnQty;
    const cgst = totalGstAmount / 2;
    const sgst = totalGstAmount / 2;
    const netAmount = taxableAmount - totalGstAmount;
    return {
      ...item,
      Return_Qty: returnQty,
      product: item.product,
      amount: parseFloat(taxableAmount.toFixed(2)),    
      cgst: parseFloat(cgst.toFixed(2)),
      sgst: parseFloat(sgst.toFixed(2)),
      totalGstAmount: parseFloat(totalGstAmount.toFixed(2)),
      netAmount: parseFloat(netAmount.toFixed(2)),
    };
  }).filter(Boolean);

  const groupedByGst = updatedDetailList.reduce((acc, item) => {
    const gst = item.gst;
    if (!acc[gst]) acc[gst] = [];
    acc[gst].push(item);
    return acc;
  }, {});

  const taxDetails = Object.entries(groupedByGst).map(([gst, items]) => {
    const gstRate = parseFloat(gst);

    const totalTaxableAmount = items.reduce((sum, item) => sum + item.amount, 0);
    const totalGstAmount = items.reduce((sum, item) => sum + item.totalGstAmount, 0);

    const cgst = (totalGstAmount / 2).toFixed(2);
    const sgst = (totalGstAmount / 2).toFixed(2);
    const totalWithGst = (totalTaxableAmount + totalGstAmount).toFixed(2);

    return {
      gst: gstRate,
      TaxableAmount: (totalTaxableAmount - totalGstAmount).toFixed(2),
      cgst,
      sgst,
      TotalWithGST: totalWithGst,
    };
  });

  setTax(taxDetails);
}, [pendingdata, inputValues]);


  useEffect(() => {
    if (pendingdata) {
      const inputValuesMap = {};
      pendingdata?.forEach((item) => {
        const rowId = item.product?._id || item._id; 
        inputValuesMap[rowId] = {
          Return_Qty: item.Return_Qty || '',
        };
      });
      setInputValues(inputValuesMap);
      
    } else {
      setPendingData([]);
      setInputValues({});
    }
  }, [pendingdata]);


  useEffect(()=>{
    console.log(selectedRows,"HELLLO SELECTED ROWS IS HERE")
  },[selectedRows,inputValues])

  const formSubmit = async (formValues) => {
    if (selectedRows.length === 0) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }
    setLoading(true);
const updatedDetailList = selectedRows.map((item) => {
  const productId = typeof item.product === 'object' && item.product !== null ? item.product._id : item.product;
  const returnQty = inputValues[productId] ? inputValues[productId].Return_Qty : null;
  if (returnQty > item.bill_qty) {
    toast(`The Return Qty cannot be more than Bill Qty`, { variant: 'warning' });
    return null; 
  }
  return {
    ...item,
    Return_Qty: returnQty,
    amount: returnQty * item.mrp,
    product: item.product,
  };
}).filter(Boolean); 

    const { bill, ...cleanedFormValues } = formValues;
    const payload = {
      ...cleanedFormValues,
      productDetails: updatedDetailList,
      taxDetails: tax
    };
  
    let editFlag = false;
    if (pendingdata && currentAction === 'edit') {
      editFlag = true;
    }

    console.log(payload,"PAYLOAD IS HERE.")
  
    const response = await request(editFlag ? '/retail-sale-return-update' : '/retail-sale-return-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRowsdata._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
  
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Retail Sale Return`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Retail Sale Return`, { variant: 'error' });
    }
  
    setLoading(false);
  };
  

  const handleRowDelete = (rowId) => {
    setDetailList((prev) =>
      prev.filter((data) => {
        return data.product !== rowId;
      })
    );
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/consignment-receipt-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Return', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Return', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRetailPosDataObj({ loading: true });
    const response = await request('/retail-sale-return-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setRetailPosDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error'});
      setRetailPosDataObj({ loading: false });
    }
  };


  const handleFetchPos = async () => {
    setPosDialogueOpen(true);
    setRetailPosDataObj({ loading: true });
    try {
      const response = await request('/retail-sale-list', { method: 'GET' });
      if (response.success) {
        setRetailPosDataObj({ loading: false, data: response.data });
        setSelectedPos({ loading: false, data: response.data });
      } else {
        toast('Error in fetching retail sale data', { variant: 'error' });
        setRetailPosDataObj({ loading: false });
      }
    } catch (error) {
      toast('An unexpected error occurred', { variant: 'error' });
      setRetailPosDataObj({ loading: false });
    }
  };
  
  useEffect(()=>{
    handlePosSearch()
  },[inputPos])

  const handlePosSearch = async () => {
    const lowercasedInput = inputPos.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/retail-sale-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setRetailPosDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setRetailPosDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setRetailPosDataObj({ loading: false, data: [] });
    }
  };
  

  const handlePosChange=(e)=>{
    setInputPos(e.target.value)
  }

  useEffect(() => {
    if (consignmentDataObj.data && consignmentDataObj.data.length > 0) {
      setOriginalData(consignmentDataObj.data);
      setIsFiltered(false);
    }
  }, [consignmentDataObj.data]);

  useEffect(() => {
    handleReturnSearch();
  }, [input]);

  const handleReturnSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/retail-sale-return-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setRetailPosDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setRetailPosDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setRetailPosDataObj({ loading: false, data: [] });
    }
  };
 
  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getWarehouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(() => {
    getWarehouseDropdown();
    getAccountLedgerData();
  }, [getWarehouseDropdown, getAccountLedgerData]);

  const summary = watch('show_summary');
  useEffect(() => {
    const totalReturnQty = Object.values(inputValues).reduce((total, item) => {
      const qty = parseFloat(item.Return_Qty) || 0;
      return total + qty;
    }, 0);
    setValue('ret_qty', totalReturnQty);
  }, [inputValues, setValue]);



  const FetchPendingBillQtyData = async (bill_no) => {
    if (!bill_no) {
      toast('Bill number is required', { variant: 'warning' });
      return;
    }
    try {
      const response = await request('/retail-sale-pending-product-list', {
        method: 'GET',
        query: { bill_no }
      });
  
      if (response?.success) {
        const detailList = response?.data?.productDetails || [];
        setPendingData(detailList);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPendingData([]);
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPendingData([]);
    }
  };
  

  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }

    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }

    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };
  
useEffect(()=>{
 const totalBillQty = selectedRows.reduce((acc, item) => acc + item.bill_qty, 0);
 setValue('bill_qty',totalBillQty)
},[selectedRows])


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Retail Return
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={()=>{
                    setCurrentAction('new')
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Retail No.</Typography>
                  <TextField disabled sx={{ flex: 0.4 }} name="retail_no" />
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.4 }}
                    name="location"
                    placeholder="Location"
                    menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Ret No.</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="ret_no" placeholder="Ret No" />
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Return Date</Typography>
                  <TextField disabled sx={{ flex: 0.4 }} name="date" placeholder="Return Date" type="date" />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Account</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="account"
                    placeholder="Select Account"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data.ledger_name,
                      _id: data?._id
                    }))}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.85 }}
                    name="remarks"
                    placeholder="Enter Reason For Return"
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Paymode</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="pay_mode"
                    placeholder="Paymode"
                    menus={PHARMACY_INVOICE_FROM}
                  />
                </Stack>
              </Stack>
            </Box>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, boxShadow: '0px 2px 2px #0099ff' }}
            >
              <Stack spacing={1} direction="row" justifyContent="space-between">
                <Button
                  variant="contained"
                  disabled={!['new', 'edit'].includes(currentAction)}
                  onClick={() => {
                    setPosDialogueOpen(true);
                    handleFetchPos();
                  }}
                >
                  Add Details
                </Button>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="view_column"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                    View All Columns in Table
                  </Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="show_summary"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Show Summary</Typography>
                </Stack>
              </Stack>
              <SelectDoctorTable
                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                const data = {pendingdata?.map((item) => ({
                  ...item,
                  _id: item.product?._id || item.product
                })) || []}
                columns={BILL_TABLE_HEADER}
                size="small"
                showInputField={true}
                handleInputChange={handleInputChange}
                inputValues={inputValues}
                loading={loading}
                onSumChange={handleSumChange}
                showOk={true}
                isSelected={isSelected}
                handleRowSelect={handleRowSelect}
                currentAction={currentAction}
                selectedRows={selectedRows}
              />
            </Grid>
            {summary && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'5rem'}>
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={tax || []}
                  columns={TAX_SUMMARY_HEADER}
                  size="small"
                  onDeleteHandler={handleRowDelete}
                />
                <Stack sx={{ flex: 1 ,marginTop:"5%"}} spacing={0.5} direction="column">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}> Bill Qty</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill_qty" />
                    <Typography sx={{ flex: 0.38, fontWeight: 700, fontSize: '1.4rem' }}>Return Qty</Typography>
                    <TextField name="ret_qty" disabled sx={{ flex: 0.3 }} />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Item Tot. Amt</Typography>
                    <TextField disabled sx={{ flex: 0.25 }} name="item_total_amt" />
                  </Stack>
                  {/* <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Bill Dis</Typography>
                    <TextField disabled sx={{ flex: 0.32 }} name="bill_dis" />
                    <Typography sx={{ flex: 0.38, fontWeight: 700, fontSize: '1.4rem' }}>Round Off</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="round_off" />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Net Amount</Typography>
                    <TextField disabled sx={{ flex: 0.27 }} name="net_amt" />
                  </Stack> */}
                </Stack>
              </Stack>
            )}
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Sales Return Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{ 
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
             }}
            label="Search By Return No."
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={retailPosDataObj?.data || []}
          loading={retailPosDataObj.loading}
          onRowClick={(row) => {
            setPendingData(row?.productDetails);
            setSelectedRowsData(row)
            setOpenQueryDialog(false);
            setValue("ret_no",row.ret_no)
            setValue('retail_no',row?.retail_no)
            setValue('account',row?.account?._id)
            setValue('remarks',row?.remarks)
            setValue('pay_mode',row?.pay_mode)
          }}
        />
      </Dialog>
      <Dialog
        open={posDialogueOpen}
        onClose={() => setPosDialogueOpen(false)}
        PaperProps={{ sx: { width: '50%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Select Bill No.
          </Typography>
          <IconButton onClick={() => setPosDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' 
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' 
              }
            }}
            label="Search Patient"
            variant="outlined"
            onChange={handlePosChange}
            value ={inputPos}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_TABLE_COLUMNS}
          data={retailPosDataObj?.data || []}
          loading={retailPosDataObj.loading}
          onRowClick={(row) => {
            FetchPendingBillQtyData(row.inv_no)
            setPosDialogueOpen(false);
            const detailListWithInvNo = row.productDetails.map((item) => ({
              ...item, 
              inv_no: row?.inv_no 
            }));
            setDetailList(detailListWithInvNo);
            setValue('bill_dis', selectedPos?.dis_per);
            setValue('retail_no',row?.inv_no)
            setValue('account',row?.ledger?._id)
          }}
        />
      </Dialog>
    </>
  );
};
